import { getBuildPrice as invokeGetBuildPrice } from "common/functions/api/buildPrices";
import { useCallback } from "react";

export const useBuildPriceHooks = (
  setFatal: (error?: string | null | undefined) => void
) => {
  const getBuildPrice = useCallback(
    async (year: number | null | undefined) => {
      const res = await invokeGetBuildPrice(year || undefined).catch(
        (error) => {
          setFatal(error);
          return undefined;
        }
      );

      if (res?.getBuildPrice) {
        const buildPrice = res.getBuildPrice;
        return buildPrice;
      }
    },
    [setFatal]
  );

  return {
    getBuildPrice
  } as const;
};
